import React from 'react';
import { handleNavigate, formatDate, formatIndianCurrency } from '../../utils/Utils';

const OverDue = ({ el, navigate, customerNumber, labels }) => {
    return (
        <div className="bg-red-500 text-[white] my-1 text-black p-4 rounded-tl-none rounded-tr-none rounded-b-[15px] fs-30w">
            <div className="grid grid-cols-2 gap-2">
                <div>{labels.health}</div>
                <div className='justify-self-end'>{el.LoanHealth}</div>
                <div>{labels.customerNumber}</div>
                <div className='justify-self-end'>{customerNumber}</div>
                <div>{labels.mobileNumber}</div>
                <div className="justify-self-end">{el.Mobile}</div>
                <div>{labels.outstandingBalance}</div>
                <div className="justify-self-end">{formatIndianCurrency(el.BalanceOutstanding)}</div>
                <div>{labels.instalmentNumber}</div>
                <div className="justify-self-end">{el.InstalmentNumber}</div>
                <div>{el.LoanHealth === "Overdue" ? labels.dueDate : labels.nextDueDate}</div>
                <div className="justify-self-end">{formatDate(el.NextInstalmentDetails.DueDate)}</div>
                <div>{labels.amountDue}</div>
                <div className="justify-self-end text-lg">{formatIndianCurrency(el.NextInstalmentDetails.AmountDue)}</div>
            </div>
            <div className="flex justify-center">
                <button className="mt-4 bg-white text-green-800 px-4 py-2 rounded-lg" onClick={() => { handleNavigate(navigate, `/payment/${customerNumber}`) }}>
                    {labels.payDue}
                </button>
            </div>
        </div>
    );
}

export default OverDue;
